// import React, { useState } from 'react';
// import './Accordion.css';

// const styles = `
// .accordion-custom {
//     width: 100%;
//     padding: 10px 15px;
//     text-align: left;
//     background-color: #00b4dbc7!important;
//     border: 1px solid #dee2e6;
//     position: relative;
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
// }

// .accordion-custom.active {
//     background-color: #a32424 !important;
//     color: white;
// }

// .table-section-title {
//     background-color: #e9ecef;
//     padding: 8px 12px;
//     margin-top: 10px;
//     margin-bottom: 0;
//     font-weight: 600;
//     border: 1px solid #dee2e6;
// }

// .section-description {
//     padding: 12px;
//     margin: 10px 0;
//     background-color: #f8f9fa;
//     border: 1px solid #dee2e6;
// }
// `;

// const ContactAccordion = () => {
//     const sections = {
//         left: [
//             {
//                 title: 'ERP/Admin Services (Formerly ACSS)',
//                 content: {
//                     academicSoftwareHelp: {
//                         title: "",
//                         contacts: [
//                             {
//                                 name: 'Amrish Kumar Sharma',
//                                 designation: 'System Architect',
//                                 landline: '011 2659 XXXX',
//                                 email: 'amrish@cc.iitd.ac.in'
//                             },
//                             {
//                                 name: 'Bharat Wadhwa',
//                                 designation: 'Information Officer',
//                                 landline: '011 2659 7125',
//                                 email: 'a26902@cc.iitd.ac.in'
//                             },
//                             {
//                                 name: 'Bidisha Roy',
//                                 designation: 'Application Analyst',
//                                 landline: '011 2659 7141',
//                                 email: 'roybidisha@cc.iitd.ac.in'
//                             },
//                             {
//                                 name: 'Gaurav Munjal',
//                                 designation: 'System Manager',
//                                 landline: '011 2659 7389',
//                                 email: 'gmunjal@cc.iitd.ac.in'
//                             },
//                             {
//                                 name: 'K.Narayanan',
//                                 designation: 'Senior System Manager - SG',
//                                 landline: '011 2659 1469',
//                                 email: 'knraj@cc.iitd.ac.in'
//                             },
//                             {
//                                 name: 'M. M. Rao',
//                                 designation: 'System Manager',
//                                 landline: '011 2659 1238',
//                                 email: 'manepali@civil.iitd.ac.in'
//                             },
//                             {
//                                 name: 'P.K. Baboo',
//                                 designation: 'Senior System Manager - SG',
//                                 landline: '011 2659 6550',
//                                 email: 'prvnjn@cc.iitd.ac.in'
//                             },
//                             {
//                                 name: 'P.K. Gupta',
//                                 designation: 'Senior System Manager - SG',
//                                 landline: '011 2659 7117',
//                                 email: 'pardeep@cc.iitd.ac.in'
//                             },
//                             {
//                                 name: 'Sonal Swarnima',
//                                 designation: 'Principal System Analyst',
//                                 landline: '011 2659 XXXX',
//                                 email: 'sonal@cc.iitd.ac.in'
//                             },
//                             {
//                                 name: 'Sudesh Bansal',
//                                 designation: 'Senior Data Processor',
//                                 landline: '011 2659 7110',
//                                 email: 'ird1708@cc.iitd.ac.in'
//                             }
//                         ]
//                     },
//                     scientificSoftwareHelp: {
//                         title: "Support ",
//                         contacts: [
//                             {
//                                 name: 'Suryamani',
//                                 designation: 'Technical Assistant',
//                                 landline: '011 2659 7141',
//                                 email: 'ird11529@cc.iitd.ac.in'
//                             }
//                         ]
//                     }
//                 }
//             },
//             {
//                 title: 'Proxy Services',
//                 content: [
//                     {
//                         name: 'Ajay Guleria',
//                         designation: 'Senior System Manager - SG',
//                         landline: '011 2659 7180',
//                         email: 'gajay@cc.iitd.ac.in'
//                     },
//                     {
//                         name: 'Gopal Krishen',
//                         designation: 'Senior System Manager - SG',
//                         landline: '011 2659 7266',
//                         email: 'kgopal@cc.iitd.ac.in'
//                     },
//                     {
//                         name: 'Sudeep Narayan Banerjee',
//                         designation: 'System Architect',
//                         landline: '011 2654',
//                         email: 'snbanerjee@cc.iitd.ac.in'
//                     }
//                 ]
//             },
//             {
//                 title: 'Cloud Computing',
//                 content: [
//                     {
//                         name: 'Admin Baadal',
//                         designation: 'Admin',
//                         landline: '011 2659 1771',
//                         email: 'baadalsupport@cc.iitd.ac.in'
//                     },
//                     {
//                         name: 'Ajay Guleria',
//                         designation: 'Senior System Manager - SG',
//                         landline: '011 2659 7180',
//                         email: 'gajay@cc.iitd.ac.in'
//                     },
//                     {
//                         name: 'Gopal Krishen',
//                         designation: 'Senior System Manager - SG',
//                         landline: '011 2659 7266',
//                         email: 'kgopal@cc.iitd.ac.in'
//                     },
//                     {
//                         name: 'Sambhav Jain',
//                         designation: 'System Architect',
//                         landline: '011 2659 1773',
//                         email: 'sambhav@cc.iitd.ac.in'
//                     },
//                     {
//                         name: 'Sonal Swarnima',
//                         designation: 'Principal System Analyst',
//                         landline: '011 2659 1771',
//                         email: 'sonal.swarnima@cc.iitd.ac.in'
//                     },
//                     {
//                         name: 'Sudeep Narayan Banerjee',
//                         designation: 'System Architect',
//                         landline: '011 2654',
//                         email: 'snbanerjee@cc.iitd.ac.in'
//                     }
//                 ]
//             },
//             {
//                 title: 'Network',
//                 content: [
//                     {
//                         name: 'Ajay Guleria',
//                         designation: 'Senior System Manager - SG',
//                         landline: '011 2659 7180',
//                         email: 'gajay@cc.iitd.ac.in'
//                     },
//                     {
//                         name: 'R. K. Chauhan',
//                         designation: 'System Manager',
//                         landline: '011 2659 7123',
//                         email: 'rkchauhan@cc.iitd.ac.in'
//                     },
//                     {
//                         name: 'Sambhav Jain',
//                         designation: 'System Architect',
//                         landline: '011 2659 1773',
//                         email: 'sambhav@cc.iitd.ac.in'
//                     }
//                 ]
//             },
//             {
//                 title: 'Cyber Security',
//                 content: [
//                     {
//                         name: 'Ajay Guleria',
//                         designation: 'Senior System Manager - SG',
//                         landline: '011 2659 7180',
//                         email: 'gajay@cc.iitd.ac.in'
//                     },
//                     {
//                         name: 'Manish Agarwal',
//                         designation: 'System Manager',
//                         landline: '011 2659 7170',
//                         email: 'zmanish@cc.iitd.ac.in'
//                     },
//                     {
//                         name: 'Sambhav Jain',
//                         designation: 'System Architect',
//                         landline: '011 2659 1773',
//                         email: 'sambhav@cc.iitd.ac.in'
//                     },
//                     {
//                         name: 'Sonal Swarnima',
//                         designation: 'Principal System Analyst',
//                         landline: '011 2659 1771',
//                         email: 'sonal.swarnima@cc.iitd.ac.in'
//                     },
//                     {
//                         name: 'Sudeep Narayan Banerjee',
//                         designation: 'System Architect',
//                         landline: '011 2654',
//                         email: 'snbanerjee@cc.iitd.ac.in'
//                     }
//                 ]
//             },
//             {
//                 title: 'HPC',
//                 content: [
//                     {
//                         name: 'HPC Admin',
//                         designation: 'Help Desk',
//                         landline: '011 2659 7137',
//                         email: 'hpchelp@iitd.ac.in'
//                     },
//                     {
//                         name: 'Manish Agarwal',
//                         designation: 'System Manager',
//                         landline: '011 2659 7170',
//                         email: 'zmanish@cc.iitd.ac.in'
//                     },
//                     {
//                         name: 'Sudeep Narayan Banerjee',
//                         designation: 'System Architect',
//                         landline: '011 2654',
//                         email: 'snbanerjee@cc.iitd.ac.in'
//                     }
//                 ]
//             },
//             {
//                 title: 'VPN',
//                 content: [
//                     {
//                         name: 'Ajay Guleria',
//                         designation: 'Senior System Manager - SG',
//                         landline: '011 2659 7180',
//                         email: 'gajay@cc.iitd.ac.in'
//                     },
//                     {
//                         name: 'Gopal Krishen',
//                         designation: 'Senior System Manager - SG',
//                         landline: '011 2659 7266',
//                         email: 'kgopal@cc.iitd.ac.in'
//                     },
//                     {
//                         name: 'Sambhav Jain',
//                         designation: 'System Architect',
//                         landline: '011 2659 1773',
//                         email: 'sambhav@cc.iitd.ac.in'
//                     },
//                     {
//                         name: 'Sonal Swarnima',
//                         designation: 'Principal System Analyst',
//                         landline: '011 2659 1771',
//                         email: 'sonal.swarnima@cc.iitd.ac.in'
//                     }
//                 ]
//             },
//             {
//                 title: 'Software',
//                 content: {
//                     academicSoftwareHelp: {
//                         title: "Academic ",
//                         contacts: [
//                             {
//                                 name: 'Academic Software Help',
//                                 designation: 'N/A',
//                                 landline: '011 2659 -',
//                                 email: 'acadsoft@cc.iitd.ac.in'
//                             },
//                             {
//                                 name: 'Gopal Krishen',
//                                 designation: 'Senior System Manager - SG',
//                                 landline: '011 2659 7266',
//                                 email: 'kgopal@cc.iitd.ac.in'
//                             }
//                         ]
//                     },
//                     scientificSoftwareHelp: {
//                         title: "Scientific ",
//                         contacts: [
//                             {
//                                 name: 'Jaya Srivastava',
//                                 designation: 'System Architect',
//                                 landline: '011 2659 7193',
//                                 email: 'jaya@cc.iitd.ac.in'
//                             },
//                             {
//                                 name: 'Manish Agarwal',
//                                 designation: 'System Manager',
//                                 landline: '011 2659 7170',
//                                 email: 'zmanish@cc.iitd.ac.in'
//                             },
//                             {
//                                 name: 'Scientific Software Help',
//                                 designation: 'N/A',
//                                 landline: '011 2659 -',
//                                 email: 'scisoft@cc.iitd.ac.in'
//                             },
//                             {
//                                 name: 'Sudeep Narayan Banerjee',
//                                 designation: 'System Architect',
//                                 landline: '011 2654',
//                                 email: 'snbanerjee@cc.iitd.ac.in'
//                             }
//                         ]
//                     }
//                 }
//             }
//         ],
//         right: [
//             {
//                 title: 'Lab Booking',
//                 content: [{
//                     name: 'Jaya Srivastava',
//                     designation: 'System Architect',
//                     landline: '011 2659 7193',
//                     email: 'jaya@cc.iitd.ac.in'
//                 }]
//             },
//             {
//                 title: 'Email Services',
//                 content: [
//                     {
//                         name: 'Ashish Kumar Singh',
//                         designation: 'System Architect',
//                         landline: '011 2659 7121',
//                         email: 'aks@cc.iitd.ac.in'
//                     },
//                     {
//                         name: 'Gopal Krishen',
//                         designation: 'Senior System Manager - SG',
//                         landline: '011 2659 7266',
//                         email: 'kgopal@cc.iitd.ac.in'
//                     },
//                     // {
//                     //     name: 'Pragya Jain',
//                     //     designation: 'System Manager',
//                     //     landline: '011 2659 1783',
//                     //     email: 'pragya@cc.iitd.ac.in'
//                     // }
//                 ]
//             },
//             {
//                 title: 'User Account',
//                 content: [{
//                     name: 'Lata',
//                     designation: 'N/A',
//                     landline: '011 2659 1771',
//                     email: 'out800304@cc.iitd.ac.in'
//                 }]
//             },
//             {
//                 title: 'SLA',
//                 content: [{
//                     name: 'Raj Kumar Chauhan',
//                     designation: 'System Manager',
//                     landline: '011 2659 7126',
//                     email: 'rkchauhan@cc.iitd.ac.in'
//                 }]
//             },
//             {
//                 title: 'Systems (Git, Repo)',
//                 content: [
//                     {
//                         name: 'Ashish Kumar Singh',
//                         designation: 'System Architect',
//                         landline: '011 2654 7121',
//                         email: 'aks@cc.iitd.ac.in'
//                     },
//                     {
//                         name: 'Gopal Krishen',
//                         designation: 'Senior System Manager - SG',
//                         landline: '011 2659 7266',
//                         email: 'kgopal@cc.iitd.ac.in'
//                     }
//                 ]
//             },
//             {
//                 title: 'Reception',
//                 content: [{
//                     name: 'Lata',
//                     designation: 'N/A',
//                     landline: '011 2659 1771',
//                     email: 'out800304@cc.iitd.ac.in'
//                 }]
//             },
//             {
//                 title: 'Web Group',
//                 content: {
//                     generalWebsite: {
//                         description: "For general enquiries related to websites, please write to webmaster@admin.iitd.ac.in",
//                         contacts: [
//                             {
//                                 name: 'Jaya Srivastava',
//                                 designation: 'System Architect',
//                                 landline: '011 2659 7193',
//                                 email: 'Jaya@cc.iitd.ac.in'
//                             },
//                             {
//                                 name: 'K.Narayanan',
//                                 designation: 'Senior System Manager - SG',
//                                 landline: '011 2659 1469',
//                                 email: 'knraj@cc.iitd.ac.in'
//                             },
//                             {
//                                 name: 'Manish Agarwal',
//                                 designation: 'System Manager',
//                                 landline: '011 2659 7170',
//                                 email: 'zmanish@cc.iitd.ac.in'
//                             }
//                         ]
//                     },
//                     recruitmentAnnouncements: {
//                         title: "Recruitment/Tenders/Announcements",
//                         contacts: [
//                             {
//                                 name: 'Bharat Wadhwa',
//                                 designation: 'Information Officer',
//                                 landline: '011 2659 7125',
//                                 email: 'a26902@cc.iitd.ac.in'
//                             }
//                         ]
//                     },
//                     CommunicationCell: {
//                         title: "Communication Cell",
//                         contacts: [
//                             {
//                                 name: 'Neha Chaudhary',
//                                 designation: 'Communication Cell',
//                                 landline: '011 2659 7124',
//                                 email: 'nehac.cstaff@cc.iitd.ac.in'
//                             }
//                         ]
//                     }
//                 }
//             },
//             {
//                 title: 'Others',
//                 content: [
//                     {
//                         name: 'Gopal Krishen',
//                         designation: 'Senior System Manager - SG',
//                         landline: '011 2659 7266',
//                         email: 'kgopal@cc.iitd.ac.in'
//                     },
//                     {
//                         name: 'P.K. Gupta',
//                         designation: 'Senior System Manager - SG',
//                         landline: '011 2659 7117',
//                         email: 'pardeep@cc.iitd.ac.in'
//                     }
//                 ]
//             }
//         ]
//     };

//     const [openSections, setOpenSections] = useState([]);

//     const toggleSection = (column, index) => {
//         const sectionId = `${column}-${index}`;
//         setOpenSections(prev => {
//             if (prev.includes(sectionId)) {
//                 return prev.filter(id => id !== sectionId);
//             } else {
//                 return [...prev, sectionId];
//             }
//         });
//     };

//     const renderTable = (contacts) => (
//         <div className="table-responsive">
//             <table className="table table-sm mb-0">
//                 <thead>
//                     <tr style={{ backgroundColor: "#c21717", color: "white" }}>
//                         <th>Contact</th>
//                         <th>Landline</th>
//                         <th>Email</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {contacts.map((contact, contactIndex) => (
//                         <tr key={contactIndex}>
//                             <td>
//                                 <div className="contact-name">{contact.name}</div>
//                                 {contact.designation && (
//                                     <div className="designation">{contact.designation}</div>
//                                 )}
//                             </td>
//                             <td>{contact.landline}</td>
//                             <td className="text-lowercase">{contact.email}</td>
//                         </tr>
//                     ))}
//                 </tbody>
//             </table>
//         </div>
//     );

//     const renderWebGroupContent = (content) => {
//         return (
//             <>
//                 {/* General Website Section */}
//                 {content.generalWebsite.description && (
//                     <div className="section-description fs-6">
//                         {content.generalWebsite.description}
//                     </div>
//                 )}
//                 {renderTable(content.generalWebsite.contacts)}

//                 {/* Recruitment/Announcements Section */}
//                 <h6 className="table-section-title mt-4">
//                     {content.recruitmentAnnouncements.title}
//                 </h6>
//                 {renderTable(content.recruitmentAnnouncements.contacts)}
//                 <h6 className="table-section-title mt-4">
//                     {content.CommunicationCell.title}
//                 </h6>
//                 {renderTable(content.CommunicationCell.contacts)}
//             </>
//         );
//     };

//     const renderSoftwareGroupContent = (content) => {
//         return (
//             <>
//                 <h6 className="table-section-title mt-4">
//                     {content.academicSoftwareHelp.title}
//                 </h6>
//                 {renderTable(content.academicSoftwareHelp.contacts)}

//                 <h6 className="table-section-title mt-4">
//                     {content.scientificSoftwareHelp.title}
//                 </h6>
//                 {renderTable(content.scientificSoftwareHelp.contacts)}
//             </>
//         );
//     };

//     const renderErpGroupContent = (content) => {
//         return (
//             <>
//                 <h6 className="table-section-title mt-4">
//                     {content.academicSoftwareHelp.title}
//                 </h6>
//                 {renderTable(content.academicSoftwareHelp.contacts)}

//                 <h6 className="table-section-title mt-4">
//                     {content.scientificSoftwareHelp.title}
//                 </h6>
//                 {renderTable(content.scientificSoftwareHelp.contacts)}
//             </>
//         );
//     };

//     const renderAccordion = (column) => {
//         return sections[column].map((section, index) => (
//             <div key={`${column}-${index}`} className="accordion-item mb-2">
//                 <button
//                     onClick={() => toggleSection(column, index)}
//                     className={`accordion-custom ${openSections.includes(`${column}-${index}`) ? 'active' : ''}`}
//                 >
//                     <span>{section.title}</span>
//                     <span className="toggle-icon">
//                         {openSections.includes(`${column}-${index}`) ? '−' : '+'}
//                     </span>
//                 </button>

//                 <div className={`accordion-content ${openSections.includes(`${column}-${index}`) ? 'show' : ''}`}>
//                     {section.title === 'Web Group'
//                         ? renderWebGroupContent(section.content)
//                         : section.title === 'Software'
//                             ? renderSoftwareGroupContent(section.content)
//                             : section.title === 'ERP/Admin Services (Formerly ACSS)'
//                                 ? renderErpGroupContent(section.content)
//                                 : Array.isArray(section.content) && section.content.length > 0
//                                     ? renderTable(section.content)
//                                     : <p className="no-content">No contacts available</p>
//                     }
//                 </div>
//             </div>
//         ));
//     };

//     return (
//         <>
//             <style>{styles}</style>
//             <div className="container my-4">
//                 <h2 className="text-center mb-4">Whom to Contact</h2>

//                 <div className="row">
//                     <div className="col-md-6">
//                         <div className="accordion pe-md-2">
//                             {renderAccordion('left')}
//                         </div>
//                     </div>
//                     <div className="col-md-6">
//                         <div className="accordion ps-md-2">
//                             {renderAccordion('right')}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default ContactAccordion;


// import React, { useState, useEffect } from 'react';
// import './Accordion.css';
// import { Base_Url } from '../config';
// import { FaPlus, FaUserEdit } from 'react-icons/fa';
// import { useNavigate } from 'react-router-dom';
// import { selectUserExists } from '../redux/userSlice';
// import { useSelector } from 'react-redux';

// const ContactAccordion = () => {
//     const [sections, setSections] = useState({ left: [], right: [] });
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [openSections, setOpenSections] = useState([]);

//      const userExists = useSelector(selectUserExists);

//     useEffect(() => {
//         fetchContacts();
//     }, []);


//     const navigate = useNavigate();


//     const fetchContacts = async () => {
//         try {
//             const response = await fetch(`${Base_Url}/contacts`);
//             if (!response.ok) {
//                 throw new Error('Failed to fetch contacts');
//             }
//             const data = await response.json();
            
//             // Process the data to merge duplicate sections
//             const processedData = processSectionData(data);
//             setSections(processedData);
//             setLoading(false);
//         } catch (err) {
//             setError(err.message);
//             setLoading(false);
//         }
//     };

//     // Function to merge duplicate sections with the same ID
//     const processSectionData = (data) => {
//         const processed = { left: [], right: [] };
        
//         // Process left column
//         const leftSectionsMap = new Map();
//         data.left.forEach(section => {
//             if (!leftSectionsMap.has(section.id)) {
//                 leftSectionsMap.set(section.id, {
//                     ...section,
//                     content: [...section.content]
//                 });
//             } else {
//                 // Merge content from duplicate sections
//                 const existingSection = leftSectionsMap.get(section.id);
//                 existingSection.content = [...existingSection.content, ...section.content];
//             }
//         });
//         processed.left = Array.from(leftSectionsMap.values());
        
//         // Process right column
//         const rightSectionsMap = new Map();
//         data.right.forEach(section => {
//             if (!rightSectionsMap.has(section.id)) {
//                 rightSectionsMap.set(section.id, {
//                     ...section,
//                     content: [...section.content]
//                 });
//             } else {
//                 // Merge content from duplicate sections
//                 const existingSection = rightSectionsMap.get(section.id);
//                 existingSection.content = [...existingSection.content, ...section.content];
//             }
//         });
//         processed.right = Array.from(rightSectionsMap.values());
        
//         return processed;
//     };

//     const toggleSection = (column, index) => {
//         const sectionId = `${column}-${index}`;
//         setOpenSections(prev => {
//             if (prev.includes(sectionId)) {
//                 return prev.filter(id => id !== sectionId);
//             } else {
//                 return [...prev, sectionId];
//             }
//         });
//     };

//     const renderTable = (contacts) => (
//         <div className="table-responsive">
//             <table className="table table-sm mb-0">
//                 <thead>
//                     <tr style={{ backgroundColor: "#c21717", color: "white" }}>
//                         <th>Contact</th>
//                         <th>Landline</th>
//                         <th>Email</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {contacts.map((contact, contactIndex) => (
//                         <tr key={contactIndex}>
//                             <td>
//                                 <div className="contact-name">{contact.name}</div>
//                                 {contact.designation && (
//                                     <div className="designation">{contact.designation}</div>
//                                 )}
//                             </td>
//                             <td>{contact.landline || 'N/A'}</td>
//                             <td className="text-lowercase">{contact.email || 'N/A'}</td>
//                         </tr>
//                     ))}
//                 </tbody>
//             </table>
//         </div>
//     );

//     const renderAccordion = (column) => {
//         return sections[column].map((section, index) => (
//             <div key={`${column}-${section.id}`} className="accordion-item mb-2">
//                 <button
//                     onClick={() => toggleSection(column, index)}
//                     className={`accordion-custom ${openSections.includes(`${column}-${index}`) ? 'active' : ''}`}
//                 >
//                     <span>{section.title} </span> <span>{section.email}</span>
//                      <span className="toggle-icon">
//                         {openSections.includes(`${column}-${index}`) ? '−' : '+'}
//                     </span>
//                 </button>

//                 <div className={`accordion-content ${openSections.includes(`${column}-${index}`) ? 'show' : ''}`}>
//                     {section.content && section.content.length > 0 
//                         ? renderTable(section.content)
//                         : <p className="no-content p-3">No contacts available</p>
//                     }
//                 </div>
//             </div>
//         ));
//     };

//     if (loading) {
//         return <div className="container my-4 text-center">Loading contacts...</div>;
//     }

//     if (error) {
//         return <div className="container my-4 text-center text-danger">Error: {error}</div>;
//     }

//     return (
//         <div className="container my-4">
//             <h2 className="text-center mb-4">Whom to Contact 
//                   {userExists && (
//                         <span className='ms-3'><FaUserEdit  onClick={()=>navigate('/admin-contact-manager')} /></span>
//                         )}
                
                
//                 </h2>

//             <div className="row">
//                 <div className="col-md-6">
//                     <div className="accordion pe-md-2">
//                         {renderAccordion('left')}
//                     </div>
//                 </div>
//                 <div className="col-md-6">
//                     <div className="accordion ps-md-2">
//                         {renderAccordion('right')}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default ContactAccordion;
import React, { useState, useEffect } from 'react';
import './Accordion.css';
import { Base_Url } from '../config';
import { FaUserEdit } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { selectUserExists } from '../redux/userSlice';
import { useSelector } from 'react-redux';

const ContactAccordion = () => {
    const [sections, setSections] = useState({ left: [], right: [] });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [openSections, setOpenSections] = useState(new Set());
    const [expandAll, setExpandAll] = useState(false);

    const userExists = useSelector(selectUserExists);

    useEffect(() => {
        fetchContacts();
    }, []);

    const navigate = useNavigate();

    const fetchContacts = async () => {
        try {
            const response = await fetch(`${Base_Url}/contacts`);
            if (!response.ok) {
                throw new Error('Failed to fetch contacts');
            }
            const data = await response.json();
            
            // Process the data to merge duplicate sections
            const processedData = processSectionData(data);
            setSections(processedData);
            setLoading(false);
        } catch (err) {
            setError(err.message);
            setLoading(false);
        }
    };

    // Function to merge duplicate sections with the same ID
    const processSectionData = (data) => {
        const processed = { left: [], right: [] };
        
        // Process left column
        const leftSectionsMap = new Map();
        data.left.forEach(section => {
            if (!leftSectionsMap.has(section.id)) {
                leftSectionsMap.set(section.id, {
                    ...section,
                    content: [...section.content]
                });
            } else {
                // Merge content from duplicate sections
                const existingSection = leftSectionsMap.get(section.id);
                existingSection.content = [...existingSection.content, ...section.content];
            }
        });
        processed.left = Array.from(leftSectionsMap.values());
        
        // Process right column
        const rightSectionsMap = new Map();
        data.right.forEach(section => {
            if (!rightSectionsMap.has(section.id)) {
                rightSectionsMap.set(section.id, {
                    ...section,
                    content: [...section.content]
                });
            } else {
                // Merge content from duplicate sections
                const existingSection = rightSectionsMap.get(section.id);
                existingSection.content = [...existingSection.content, ...section.content];
            }
        });
        processed.right = Array.from(rightSectionsMap.values());
        
        return processed;
    };

    const toggleSection = (column, index) => {
        const sectionId = `${column}-${index}`;
        setOpenSections(prev => {
            const newSet = new Set(prev);
            if (newSet.has(sectionId)) {
                newSet.delete(sectionId);
            } else {
                newSet.add(sectionId);
            }
            return newSet;
        });
    };

    const toggleExpandAll = () => {
        if (expandAll) {
            setOpenSections(new Set());
        } else {
            const allSections = new Set();
            sections.left.forEach((_, index) => allSections.add(`left-${index}`));
            sections.right.forEach((_, index) => allSections.add(`right-${index}`));
            setOpenSections(allSections);
        }
        setExpandAll(!expandAll);
    };

    const isSectionOpen = (column, index) => {
        return openSections.has(`${column}-${index}`);
    };

    const renderTable = (contacts) => (
        <div className="contact-accordion-table-responsive">
            <table className="contact-accordion-table">
                <thead>
                    <tr>
                        <th>Contact</th>
                        <th>Landline</th>
                        <th>Email</th>
                    </tr>
                </thead>
                <tbody>
                    {contacts.map((contact, contactIndex) => (
                        <tr key={contactIndex}>
                            <td>
                                <div className="contact-accordion-name">{contact.name}</div>
                                {contact.designation && (
                                    <div className="contact-accordion-designation">{contact.designation}</div>
                                )}
                            </td>
                            <td>{contact.landline || 'N/A'}</td>
                            <td className="text-lowercase">{contact.email || 'N/A'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );

    const renderAccordion = (column) => {
        return sections[column].map((section, index) => {
            const sectionId = `${column}-${index}`;
            const isOpen = isSectionOpen(column, index);
            
            return (
                <div key={sectionId} className="contact-accordion-item">
                    <button
                        onClick={() => toggleSection(column, index)}
                        className={`contact-accordion-button ${isOpen ? 'active' : ''}`}
                        aria-expanded={isOpen}
                    >
                        <span className="contact-accordion-section-title">
                            {section.title}
                            {section.email && <span className="contact-accordion-email-text"> ({section.email})</span>}
                        </span>
                        <span className="contact-accordion-toggle-icon">
                            {isOpen ? '−' : '+'}
                        </span>
                    </button>

                    <div className={`contact-accordion-content ${isOpen ? 'show' : ''}`}>
                        {section.content && section.content.length > 0 
                            ? renderTable(section.content)
                            : <p className="contact-accordion-no-content">No contacts available</p>
                        }
                    </div>
                </div>
            );
        });
    };

    if (loading) {
        return <div className="contact-accordion-container my-4 text-center">Loading contacts...</div>;
    }

    if (error) {
        return <div className="contact-accordion-container my-4 text-center text-danger">Error: {error}</div>;
    }

    return (
        <div className="contact-accordion-container my-4">
            <div className="contact-accordion-header">
                <h2 className="contact-accordion-heading">Whom to Contact</h2>
                {userExists && (
                    <FaUserEdit 
                        onClick={() => navigate('/admin-contact-manager')} 
                        className="contact-accordion-edit-icon"
                        title="Edit Contacts"
                    />
                )}
                <button 
                    onClick={toggleExpandAll}
                    className={`contact-accordion-toggle-all ${expandAll ? 'active' : ''}`}
                    title={expandAll ? 'Collapse All' : 'Expand All'}
                >
                    {expandAll ? 'Collapse All' : 'Expand All'}
                </button>
            </div>

            <div className="contact-accordion-row">
                <div className="contact-accordion-col">
                    <div className="contact-accordion">
                        {renderAccordion('left')}
                    </div>
                </div>
                <div className="contact-accordion-col">
                    <div className="contact-accordion">
                        {renderAccordion('right')}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactAccordion;